import shop from './shop'
import content from './content'
import posts from './posts'
import order from './order'
import orderStatus from './orderStatus'
import site from './site'

const reducers = {
  shop,
  content,
  posts,
  order,
  orderStatus,
  site
}

export default reducers


// WEBPACK FOOTER //
// ./src/reducers/index.js